import Img from 'gatsby-image'
import PropTypes from 'prop-types'
import React from 'react'

const ProductPreview = ({ className, title, description, imageUrl }) => (
  <div className={className}>
    <Img fluid={imageUrl.childImageSharp.fluid} alt={title}/>
    <div className="has-text-centered">
      <p className="has-text-weight-bold">{title}</p>
      <p>{description}</p>
    </div>
  </div>
)

ProductPreview.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  imageUrl: PropTypes.string,
}

export default ProductPreview
